import { render, staticRenderFns } from "./formattedIncidentReportBackToWork.vue?vue&type=template&id=6f68bf2a"
import script from "./formattedIncidentReportBackToWork.vue?vue&type=script&lang=js"
export * from "./formattedIncidentReportBackToWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports